import React from "react";
import SignInImageView from "../components/SignInImageView.js";
import SignInRootUserWindow from "../components/SignInRootUserWindow.js";
import "../styles/SignInRootUser.css";

function SignInRootUser() {
  return (
    <div className="signin-main-container-root">
      <div className="signin-image-view-container">
        <SignInImageView />
      </div>
      <div className="dont-have-acc-container">
        <div className="dont-have-acc-container-text">
          Don’t have an account?
        </div>
        <div
          className="dont-have-acc-container-link"
          onClick={() => {
            window.open(
              `${process.env.REACT_APP_DEV_ENVIROMET_URL}/register`,
              "_blank",
            );
          }}
        >
          Sign UP
        </div>
      </div>
      <SignInRootUserWindow />
    </div>
  );
}

export default SignInRootUser;
